import React, {useState} from 'react';
import MinutesInfo from './Info.js';
import MinutesHeader from './Header.js';
import {
  Button,
  Col,
  Form,
  Modal,
  Row
} from 'react-bootstrap';

function Minutes({onHide, onSubmit, schedule}) {

  const [statement, setStatement] = useState();

  return (
    <Modal
      size="lg"
      show={true}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/* <MinutesHeader /> */}
      <Modal.Header >
        <Modal.Title id="example-modal-sizes-title-lg">Minutes of Audit</Modal.Title>
        <button type="button" class="close" onClick={onHide}>&times;</button>
      </Modal.Header>
      <Modal.Body>
        <MinutesInfo schedule={schedule} />
        <hr/>
        <Row>
          <Col md="12">
            <Form.Group>
              <Form.Label>Auditor's General Statement*:</Form.Label>
              <Form.Control
                value={statement}
                onChange={({ target: { value }}) => setStatement(value)}
                as="textarea"
                rows={4}
                isInvalid={statement?.length > 4000}
              />
              <Form.Text id="passwordHelpBlock" muted>
                Total characters: {statement?.length ?? 0} / 4000
              </Form.Text>
            </Form.Group>
          </Col>

        </Row>
        <Row>
          <Col md="12">
            <Form.Group>
              <Form.Label>BPMI General Statement*:</Form.Label>
              <Form.Control disabled as="textarea" rows={4} />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer style={{ justifyContent: 'flex-end', gap: '10px' }}>
        <Button onClick={() => onSubmit(statement)} variant="primary">Submit</Button>
        <Button onClick={onHide} variant="secondary">Close</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default Minutes;